import LocomotiveScroll from 'locomotive-scroll';

export function init() {
	
	const container = document.body.querySelector('[data-scroll-container]');
	const init_position = {
        x: 0,
        y: 0
    };

    if (window.scroll_position && restore) {
    	init_position = window.scroll_position;
    }
	window.locomotive = new LocomotiveScroll({
	    el: container,
	    smooth: true,
	    offset: ['20%', '0'],
	    getDirection: true,
	    initPosition: init_position,
	    lerp: 0.1,
	    multiplier: 1,
	    firefoxMultiplier: 50,
	    touchMultiplier: 2,
	    resetNativeScroll: !0,
	    scrollFromAnywhere: true,
	});
	
	locomotive.on('call', (func, args, obj) => {
		if (func == "autoplay") {
			if (!obj.el.classList.contains('active')) {
				if (obj.inView) {
					obj.el.play();
					return;
				}

				obj.el.pause();
			}
		}
	});

	locomotive.on('scroll', (el) => {
		const footer = el.currentElements['footer'];

		if (!footer) return;

		footer.el.style.setProperty('--parallax', footer.progress);
	});

	// window.addEventListener('resize', () => {
	// 	setTimeout(() => {
	// 		locomotive.update();
	// 	}, 10);
	// })

	// locomotive.update();
}

export function reinit() {
	locomotive.destroy();
	window.scrollTo(0, 0);
	init();
}

export function update() {
	locomotive.update();
}